export enum LogsType {
  SystemLogs,
  UserLogs,
}
